// libs
import * as React from 'react'

// classes / components
import Notification, { clsHighlightedText, clsText, NotificationProps } from 'src/components/notifications/notification'
import { textResources } from 'src/lang/de'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'

const labels = textResources.notification

export type ProjectMeetingNotificationProps = {
  createdAt: string;
  meetingTitle: string | null | undefined;
  projectName: string;
} & Pick<
  NotificationProps,
  'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'
>;

const ProjectMeetingNotification: React.FC<ProjectMeetingNotificationProps> = ({
  avatarImage,
  createdAt,
  isRead,
  meetingTitle,
  onClick,
  projectName
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={projectName}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{labels.notificationNewMeeting}</span>
      {meetingTitle && (
        <strong className={clsHighlightedText}>{`„${meetingTitle}“`}</strong>
      )}
      <span className={clsText}>{labels.notificationCreated}</span>
    </Notification>
  )
}

export default ProjectMeetingNotification
